<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="add-company-tags-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
            </button>

            <h4 class="modal-title">
              Add Company Tags
            </h4>
          </div>

          <div class="modal-body">
            <TagsFormGroup
                v-model="tags"
                name="tags"
                label="Tags"
            />
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>

            <button type="submit" class="btn btn-black">
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import TagsFormGroup from '@/components/FormGroups/Block/Tags'

export default {
  components: {TagsFormGroup},

  mixins: [Errors],

  props: {
    selected: {
      type: Array
    }
  },

  data() {
    return {
      tags: []
    }
  },

  mounted() {
    this.listenForClose()
  },

  methods: {
    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    submit() {
      if (!this.selected.length) {
        notify.error('No companies selected')
      }

      // Send first request alone to potentially create the tags
      http.post('/api/v2/companies/' + this.selected[0].attributes.company_id + '/tags', {
        tags: this.tags.map(tag => ({name: tag.text}))
      }).then(() => {
        Promise
            .all(this.selected.slice(1).map(projectLead => http.post('/api/v2/companies/' + projectLead.attributes.company_id + '/tags', {
              tags: this.tags.map(tag => ({name: tag.text}))
            })))
            .then(() => {
              notify.success('The tags were added')

              this.$emit('updated')

              $(this.$el).modal('hide')
            })
      })
    },

    reset() {
      this.errors = {}

      this.tags = []
    }
  }
}
</script>
